import React, { useState, useEffect } from "react";
import Container from "react-bootstrap/Container";
import { NavLink, Link, useLocation } from "react-router-dom";
import "./navigation.css";

export default function Navigation() {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  // Sayfa değişince menüyü kapat
  useEffect(() => {
    setIsOpen(false);
  }, [location]);

  // Menü açıldığında sayfanın arkada kaymasını engelle
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isOpen]);

  const navLinks = [
    { title: "Anasayfa", path: "/" },
    { title: "Hakkımızda", path: "/hakkımızda" },
    // { title: "Programlarımız", path: "/programlar" },
    { title: "Blog", path: "/blog" },
    { title: "İletişim", path: "/iletişim" },
  ];

  return (
    <>
      <nav className="custom-navbar">
        {/* justify-content-between: Logo en solda, Menü en sağda */}
        <Container className="d-flex align-items-center justify-content-between">
          
          {/* ================= SOL: LOGO ================= */}
          <Link to="/" className="navbar-logo-link">
            <img
              src="./images/myadfdf.png"
              alt="Mevzu Yaşam Akademi Logo"
              className="navbar-brand-logo"
            />
          </Link>

          {/* ================= SAĞ: MASAÜSTÜ MENÜ ================= */}
          <div className="d-none d-md-flex desktop-nav-wrap">
            {navLinks.map((link, index) => (
              <NavLink
                key={index}
                to={link.path}
                className={({ isActive }) =>
                  `custom-nav-link ${isActive ? "active" : ""}`
                }
              >
                {link.title}
              </NavLink>
            ))}

            {/* Randevu Butonu */}
            <Link to="/iletişim" className="nav-schedule-btn shadow-sm">
              <span className="nav-schedule-text">Randevu Al</span>
              <span className="nav-schedule-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="15"
                  height="15"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#ffffff"
                  strokeWidth="2.4"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <line x1="5" y1="19" x2="19" y2="5"></line>
                  <polyline points="9 5 19 5 19 15"></polyline>
                </svg>
              </span>
            </Link>
          </div>

          {/* ================= SAĞ: MOBİL ÖZEL HAMBURGER BUTON ================= */}
          <button
            type="button"
            className={`custom-hamburger-btn d-md-none ${isOpen ? "is-active" : ""}`}
            onClick={() => setIsOpen((prev) => !prev)}
            aria-label="Menüyü Aç/Kapat"
          >
            <span className="burger-bar bar-top" />
            <span className="burger-bar bar-bottom" />
          </button>

        </Container>
      </nav>

      {/* ================= 3. MOBİL PERDE MENÜSÜ ================= */}
      <div className={`mobile-nav-curtain ${isOpen ? "open" : ""}`}>
        
        {/* Linkler */}
        <div className="mobile-nav-list">
          {navLinks.map((link, index) => (
            <NavLink
              key={index}
              to={link.path}
              className={({ isActive }) =>
                `mobile-nav-item ${isActive ? "active" : ""}`
              }
            >
              <span className="mobile-nav-index">0{index + 1}</span>
              <span className="mobile-nav-title">{link.title}</span>
            </NavLink>
          ))}
        </div>

        {/* Alt Bölüm: Beyaz Buton & Künye */}
        <div className="mobile-nav-footer">
          <Link to="/iletişim" className="mobile-cta-btn shadow-lg">
            <span>Ücretsiz Ön Görüşme</span>
            <span className="mobile-cta-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#ffffff"
                strokeWidth="2.4"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <line x1="5" y1="19" x2="19" y2="5"></line>
                <polyline points="9 5 19 5 19 15"></polyline>
              </svg>
            </span>
          </Link>

          <div className="mobile-footer-meta">
            <span>Mevzu Yaşam Akademi</span>
            <span>Online & Yüz Yüze</span>
          </div>
        </div>

      </div>
    </>
  );
}